import { Badge } from "@/components/ui/badge";
import { Award, Clock, Shield, Headphones, ThermometerSun, Users } from "lucide-react";

const WhyChooseUsSection = () => {
  const reasons = [
    {
      icon: <Award className="h-8 w-8" />,
      title: "Expert Technicians",
      description: "Our team consists of certified and experienced HVAC professionals."
    },
    {
      icon: <Clock className="h-8 w-8" />,
      title: "Quick Response",
      description: "Fast service response times to minimize your discomfort."
    },
    {
      icon: <Shield className="h-8 w-8" />,
      title: "Quality Guaranteed",
      description: "We stand behind our work with comprehensive service warranties."
    },
    {
      icon: <Headphones className="h-8 w-8" />,
      title: "24/7 Support",
      description: "Round-the-clock customer support for emergency services."
    },
    {
      icon: <ThermometerSun className="h-8 w-8" />,
      title: "Energy Efficient",
      description: "Solutions designed to reduce energy consumption and costs."
    },
    {
      icon: <Users className="h-8 w-8" />,
      title: "Customer First",
      description: "Your satisfaction is our top priority in every project."
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-black text-white" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30 mb-4">Why Choose Us</Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-testid="why-us-title">
            The MARCO AIR CONDITION Advantage
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We combine expertise, quality, and dedication to deliver the best HVAC services in Surat and across India
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-amber-500/20 hover:border-amber-500/50 hover:bg-white/10 transition-all duration-300"
              data-testid={`why-us-card-${index}`}
            >
              <div className="bg-gradient-to-br from-amber-500 to-yellow-500 w-16 h-16 rounded-xl flex items-center justify-center mb-6 text-black">
                {reason.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white">{reason.title}</h3>
              <p className="text-gray-400">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
